import { queryOptions, useQuery } from '@tanstack/react-query';
import reports from 'apis/reports';
import { DatasetDownloadJobDto, QueryConfig } from 'types';

export const getDownloadJob = ({ id, signal }: { id: string; signal?: AbortSignal }) => {
  return reports.get<DatasetDownloadJobDto>(`/datasets/download-jobs/${id}?waitFor=30`, { signal });
};

export const getDownloadJobQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ['download-job', id],
    queryFn: () => getDownloadJob({ id }),
    enabled: false, // Manual triggering
    refetchInterval: false,
  });
};

interface UseDownloadJobOptions {
  id: string;
  queryConfig?: QueryConfig<typeof getDownloadJobQueryOptions>;
}

export const useDownloadJob = ({ id, queryConfig }: UseDownloadJobOptions) => {
  return useQuery({
    ...getDownloadJobQueryOptions(id),
    ...queryConfig,
  });
};
